module.exports = __webpack_public_path__ + "static/media/12.711d9388.png";